window.detailPage = function() {
    var shareLink = function () {
        window.setShareLinks();
    };
    
    var calendar = function() {
        window.addToCalendar = function(id, status) {
            $.ajax({
                type: "POST",
                url: HOST_URL + '/events/calendar/' + id,
                data: {
                    status: status
                }
            })
            .done(function(response) {
                $('#event-calendar').html(response);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                if(403 == xhr.status) {
                    window.location.href = HOST_URL + '/email/verify';
                }
            });
        }
    }

    return {
        init: function() {
            shareLink();
            calendar();
        }
    };
}();